import { Badge } from '@mantine/core';
import { getKindBadgeColor, getKindPretty } from 'components/tables/data/kind';
import { RevisionRow } from 'components/tables/data/revision/types';

/**
 * Column for the form type (kind) of a revision row.
 */
export default function FormTypeColumn({ data: { kind } }: { data: RevisionRow }) {
  return (
    <Badge color={getKindBadgeColor(kind)} size="sm" variant="filled">
      {getKindPretty(kind)}
    </Badge>
  );
}
